import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Epics',
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'epics',
                },
              },
              subqueries: {
                epics: {
                  filter: {
                    or: [
                      { '=': [{ '`': { '``': { '@$': 'projectId' } } }, null] },
                      { '>': [{ '#': { '@': 'projectRequirements' } }, 0] },
                    ],
                  },
                  target: 'ent:!epics:!epic',
                  subqueries: {
                    projectRequirements: {
                      ref: {
                        attr: 'attr:ent#!requirements#!requirement:!epic',
                      },
                      target: 'ent:!requirements:!requirement',
                      filter: {
                        '=': [
                          { '@': 'specProject' },
                          {
                            '@>': [
                              { '`': { '``': { '@$': 'projectId' } } },
                              'recordId',
                            ],
                          },
                        ],
                      },
                      selection: { '@.': '!id' },
                      subqueries: {
                        specProject: {
                          ref: {
                            attr: 'attr:ent#!requirements#!requirement:!spec',
                          },
                          target: 'ent:!specs:!spec',
                          selection: {
                            '@.': ['!project', { ref: { entity: '!proj' } }],
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                or: [
                  { '=': [{ '`': { '``': { '@$': 'projectId' } } }, null] },
                  { '>': [{ '#': { '@': 'projectRequirements' } }, 0] },
                ],
              },
              sort: {
                by: {
                  '@.': '!id',
                },
              },
              target: 'ent:!epics:!epic',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      epic: {
                        '{}': {
                          value: {
                            '@.': '!id',
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      state: {
                        '{}': {
                          value: '✓ In Jira',
                        },
                      },
                      status: {
                        '{}': {
                          value: {
                            '@.': '!status',
                          },
                        },
                      },
                      specPath: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '@.': '!spec_path',
                              },
                              '—',
                            ],
                          },
                        },
                      },
                      requirements: {
                        '{}': {
                          value: {
                            '#': {
                              '@': 'issues',
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                projectRequirements: {
                  ref: { attr: 'attr:ent#!requirements#!requirement:!epic' },
                  target: 'ent:!requirements:!requirement',
                  filter: {
                    '=': [
                      { '@': 'specProject' },
                      {
                        '@>': [
                          { '`': { '``': { '@$': 'projectId' } } },
                          'recordId',
                        ],
                      },
                    ],
                  },
                  selection: { '@.': '!id' },
                  subqueries: {
                    specProject: {
                      ref: {
                        attr: 'attr:ent#!requirements#!requirement:!spec',
                      },
                      target: 'ent:!specs:!spec',
                      selection: {
                        '@.': ['!project', { ref: { entity: '!proj' } }],
                      },
                    },
                  },
                },
                issues: {
                  target: 'child',
                  selection: {
                    '@.': '!id',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'epic',
                  direct: {
                    '{}': {
                      name: 'Epic',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'name',
                  direct: {
                    '{}': {
                      name: 'Name',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'specPath',
                  direct: {
                    '{}': {
                      name: 'Spec Path',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'status',
                  direct: {
                    '{}': {
                      name: 'Status',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'requirements',
                  direct: {
                    '{}': {
                      name: 'Requirements',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'state',
                  direct: {
                    '{}': {
                      name: 'State',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
}
